export const templesGroup1 = [
  {
    slNo: "3",
    slug: "mahakaleshwar-ujjain",
    generalInfo: {
      templeName: "Shri Mahakaleshwar Jyotirlinga",
      templeDescription: "Shri Mahakaleshwar Jyotirlinga in Ujjain, Madhya Pradesh, is dedicated to Lord Shiva and is one of the twelve Jyotirlingas. It is distinguished as the only south-facing Jyotirlinga. The sacred lingam is enshrined on the lowest level of the multi-storey temple, close to Rudra Sagar. The temple is especially known for its pre-dawn Bhasma Aarti and is administered by the Shri Mahakaleshwar Temple Management Committee under Madhya Pradesh law.",
      location: "Ujjain, Madhya Pradesh",
      deity: "Lord Shiva (Mahakaleshwar Jyotirlinga)",
      trekPoints: [],
      dressCode: "Modest clothing for general darshan. Traditional dress is required for specified Bhasma Aarti/inner-sanctum participation; men generally wear dhoti and women saree as directed by temple authorities."
    },
    timeInfo: {
      bestTime: "October - March for pleasant weather; religiously important visits include Mahashivratri and Shravan.",
      peakTime: "Mahashivratri, Shravan/Bhadrapada Mondays, Nag Panchami, major holidays and year-end/New Year."
    },
    footfall: {
      monthlyFootfalls: [
        {
          month: "Peak Daily Range",
          totalYatra: "About 120000 daily on typical high-demand days; 150000-175000 on weekends and over 200000 on major festival days reported in 2025"
        }
      ]
    },
    registrationProcess: [
      {
        name: "Bhasma Aarti Registration",
        description: "Advance registration is required to attend the limited-capacity Bhasma Aarti. Book through the temple portal; carry the same valid government ID used for booking.",
        isMandatory: true,
        method: "Online / limited onsite arrangements when announced",
        cost: "₹200 per person reported for 2026 general Bhasma Aarti booking",
        requiredDocs: "Valid government photo ID; booking details/photo as requested by portal",
        location: "temple portal / designated temple counter",
        website: "https://www.shrimahakaleshwar.mp.gov.in/",
        validity: "For selected date and booking"
      }
    ],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "25.1", low: "11.4" },
        { month: "Feb", high: "28.1", low: "13.7" },
        { month: "Mar", high: "33.0", low: "18.2" },
        { month: "Apr", high: "37.6", low: "23.1" },
        { month: "May", high: "39.5", low: "26.2" },
        { month: "Jun", high: "35.2", low: "25.6" },
        { month: "Jul", high: "28.9", low: "23.5" },
        { month: "Aug", high: "27.5", low: "22.8" },
        { month: "Sep", high: "29.3", low: "21.8" },
        { month: "Oct", high: "31.4", low: "19.5" },
        { month: "Nov", high: "29.1", low: "16.1" },
        { month: "Dec", high: "26.1", low: "12.4" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:00 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "11:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Bhasma Aarti", time: "04:00 AM - 06:00 AM" },
        { name: "Dadyodak Aarti (Bal Bhog)", time: "07:00 AM - 07:45 AM (Chaitra-Ashwin); 07:30 AM - 08:15 AM (Kartik-Phalgun)" },
        { name: "Bhog Aarti", time: "10:00 AM - 10:45 AM (Chaitra-Ashwin); 10:30 AM - 11:15 AM (Kartik-Phalgun)" },
        { name: "Sandhya Aarti", time: "07:00 PM - 07:45 PM (Chaitra-Ashwin); 06:30 PM - 07:15 PM (Kartik-Phalgun)" },
        { name: "Shayan Aarti", time: "10:30 PM - 11:00 PM" }
      ]
    },
    transportation: [
      {
        mode: "Flight",
        startPoint: "Devi Ahilyabai Holkar Airport, Indore",
        endPoint: "Shri Mahakaleshwar Temple",
        distanceKm: 58,
        duration: "Approx. 1.5 hrs by road",
        cost: "Cab ₹479 onwards + taxes/charges; dynamic fare",
        extraInfo: "Nearest major airport; taxis/cabs connect Indore and Ujjain."
      },
      {
        mode: "Train",
        startPoint: "Ujjain Junction",
        endPoint: "Shri Mahakaleshwar Temple",
        distanceKm: 2,
        duration: "Approx. 10-20 mins by local transport",
        cost: "Shared auto up to ₹10; local bus ₹4-₹15",
        extraInfo: "Auto-rickshaws and taxis are commonly available."
      },
      {
        mode: "Bus / Road",
        startPoint: "Indore",
        endPoint: "Ujjain",
        distanceKm: 53,
        duration: "Approx. 1-1.5 hrs",
        cost: "₹63 onwards by bus",
        extraInfo: "Frequent road connectivity; continue by local transport to the temple approach."
      }
    ],
    accommodation: [
      {
        type: "Temple Committee Guest House",
        location: "Pt. Suryanarayan Vyas Atithi Niwas, near Harsiddhi Temple",
        costRange: "₹600-₹1200 for listed non-AC/AC 2-4 bed rooms",
        bookingInfo: "Operated by the temple committee; online accommodation booking is expected; verify current availability."
      },
      {
        type: "Temple Committee Guest House",
        location: "Shri Mahakaleshwar Atithi Niwas, Annakshetra Complex, Shaktipath",
        costRange: "₹1250-₹2500 for listed AC rooms/halls; extra bed ₹250",
        bookingInfo: "Operated by the temple committee; contact/availability should be confirmed before travel."
      },
      {
        type: "Hotel / Dharamshala",
        location: "Mahakal area and central Ujjain",
        costRange: "Varies",
        bookingInfo: "Multiple private hotels and dharamshalas are available near the temple."
      },
      {
        type: "Private Hotel",
        location: "Hotel Rajshree Inn, Ujjain; approx. 2.1 km from Shri Mahakaleshwar Temple",
        costRange: "Varies by date",
        bookingInfo: "Nearby private accommodation near Mahakaleshwar; verify current tariff and availability before booking."
      }
    ],
    gates: [
      {
        name: "Gate No. 1 / Avantika Gate",
        description: "Used for designated special/aarti entry; arrangements can change during festivals.",
        location: "Temple complex approach",
        isOpen: true
      },
      {
        name: "General Darshan Route",
        description: "General entry route is managed through Mahakal Lok/Mansarovar facility areas and may be altered for peak events.",
        location: "Mahakal Lok side",
        isOpen: true
      }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Locker facilities are provided at designated approach/gate areas; digital locker system available.", isAvailable: true },
      { name: "Shoe Stand", description: "Shoe stands available at designated temple approach points; locations expand/change during peak festivals.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobile phones are prohibited inside the temple premises/controlled darshan areas; use designated deposit facilities.", isAvailable: false },
      { name: "Photography", description: "Photography/cameras are not allowed in controlled temple and Bhasma Aarti areas.", isAvailable: false },
      { name: "Videography", description: "Videography is not allowed in controlled temple areas.", isAvailable: false },
      { name: "Drinking Water", description: "Safe drinking water available; additional booths are arranged on peak-event routes.", isAvailable: true },
      { name: "Toilets", description: "Public/mobile toilet facilities available around the temple approach and event routes.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free prasadi meals are served at Shri Mahakaleshwar Annakshetra, generally 11:00 AM-7:30 PM.", isAvailable: true, price: "Free at Annakshetra" },
      { name: "Prasad", description: "Laddu/prasad distribution counters are available at designated temple areas.", isAvailable: true },
      { name: "Medical Facility", description: "Avanti Hospital ~3 km. Wellness Forever Pharmacy, Sindhi Colony ~3 km (24x7).", isAvailable: true },
      { name: "Wheelchair / Accessibility Assistance", description: "Battery car assistance available for elderly devotees.", isAvailable: true },
      { name: "Parking", description: "Parking available at designated areas around the Mahakal zone; locations vary with crowd plans.", isAvailable: true },
      { name: "Sheeghra Darshan", description: "Faster darshan service with a separate queue.", isAvailable: true, price: "₹250 per person" }
    ],
    specialServices: [
      { name: "Sheeghra Darshan", description: "Faster darshan through the separate queue.", price: "₹250 per person", extraInfo: "Book online through the temple portal or use arrangements when available." },
      { name: "Bhasma Aarti Booking", description: "Pre-dawn Bhasma Aarti requires registration due to limited capacity.", price: "₹200 per person reported for general booking", extraInfo: "Regular timing 04:00 AM-06:00 AM; seasonal Shravan schedules may start earlier." },
      { name: "Sandhya Aarti Booking", description: "Online booking available for designated evening aarti viewing.", price: "₹250 per person", extraInfo: "Seasonal aarti timing applies." },
      { name: "Shayan Aarti Booking", description: "Online booking available for designated night aarti viewing.", price: "₹250 per person", extraInfo: "Shayan Aarti is normally 10:30 PM-11:00 PM." },
      { name: "Pujan / Abhishek Booking", description: "Pujan options include General Puja, Shiv Mahimn Path and several Rudrabhishek services.", price: "₹100-₹15000 depending on puja", extraInfo: "Some lower-priced pujas require a separate Sheeghra Darshan ticket." },
      { name: "Free Annakshetra", description: "Free prasadi meals for devotees.", price: "Free", extraInfo: "Daily service is generally 11:00 AM-7:30 PM." }
    ],
    nearbyPlaces: [
      { name: "Shri Mahakal Mahalok", description: "910-metre temple corridor adjoining Mahakaleshwar; generally open 06:00 AM-10:00 PM with free entry." },
      { name: "Harsiddhi Temple", description: "Major Shakti temple close to Mahakaleshwar." },
      { name: "Ram Ghat, Shipra River", description: "Important sacred ghat on the Shipra River in Ujjain." },
      { name: "Kal Bhairav Temple", description: "Prominent Bhairav temple and major Ujjain pilgrimage stop." },
      { name: "Mangalnath Temple", description: "Important Shiva temple traditionally associated with Mars (Mangal)." },
      { name: "Sandipani Ashram", description: "Ancient sacred site traditionally associated with Krishna's education." }
    ],
    images: { thumbnailImage: "https://cdn.travelpal.ai/prod/places/Yfhp3BeanrKxqYgASZ8_8QX06-U/photos/google/webp/d52ea4093bb47fe93dc26ea4.webp" },
    management: {
      trustName: "Shri Mahakaleshwar Temple Management Committee, Ujjain",
      website: "https://www.shrimahakaleshwar.mp.gov.in/",
      contactNumber: "0734-2550563; 0734-2559277; 18002331008"
    }
  },
  {
    slNo: "5",
    slug: "tirupati-balaji",
    generalInfo: {
      templeName: "Sri Venkateswara Swamy Temple",
      templeDescription: "Sri Venkateswara Swamy Temple is a major Vaishnavite shrine at Tirumala in Tirupati district, Andhra Pradesh. The presiding deity, Lord Venkateswara, is a form of Vishnu and is also known as Srinivasa, Balaji and Venkatachalapati. The temple stands on Venkata Hill in the Seshachalam range beside Swami Pushkarini and is administered by Tirumala Tirupati Devasthanams (TTD). Pilgrims can use free Sarva Darshan, paid Special Entry Darshan and several scheduled sevas; daily schedules vary by weekday and festival.",
      location: "Tirumala, Tirupati district, Andhra Pradesh",
      deity: "Lord Venkateswara (Vishnu)",
      trekPoints: [
        { name: "Alipiri Footpath to Tirumala", distanceKm: 11 },
        { name: "Srivari Mettu Footpath to Tirumala", distanceKm: 6 }
      ],
      dressCode: "Traditional dress is mandatory for Arjitha Sevas and ₹300 Special Entry Darshan. Men: dhoti with shirt/upper cloth or kurta-pyjama. Women: saree, half-saree or chudidar-pyjama with dupatta. Modest traditional clothing is recommended for all darshan."
    },
    timeInfo: {
      bestTime: "November - February for milder weather. Darshan is available year-round.",
      peakTime: "Summer holidays, weekends, Brahmotsavam, Vaikunta Ekadasi and major Vaishnavite festivals."
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Typical Daily Range", totalYatra: "60,000-80,000" },
        { month: "Heavy Rush Example", totalYatra: "90,211" },
        { month: "Major Festival Expected Range", totalYatra: "200,000-300,000" }
      ]
    },
    registrationProcess: [
      {
        name: "Sarva Darshan",
        description: "Free general darshan through the Vaikuntham Queue Complex. Waiting time varies with crowd.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "N/A",
        location: "Vaikuntham Queue Complex, Tirumala",
        website: "https://www.tirumala.org",
        validity: "For current darshan"
      },
      {
        name: "Slotted Sarva Darshan (SSD)",
        description: "Free time-slot tokens are issued first-come-first-served at notified counters, subject to availability.",
        isMandatory: false,
        method: "Onsite token",
        cost: "Free",
        requiredDocs: "Carry original government ID; Aadhaar is commonly used for TTD identity verification.",
        location: "Notified TTD counters",
        website: "https://www.tirumala.org",
        validity: "Use only in the allotted slot"
      },
      {
        name: "Special Entry Darshan",
        description: "Time-slot darshan. Report only at the allotted reporting time shown on the ticket.",
        isMandatory: false,
        method: "Online advance booking",
        cost: "₹300",
        requiredDocs: "Original ID matching booking details",
        location: "₹300 Special Entry Darshan Complex, Tirumala",
        website: "https://ttdevasthanams.ap.gov.in",
        validity: "Valid for booked date and slot"
      }
    ],
    prerequisites: [
      { name: "Booked Darshan/Seva Ticket", description: "Report at the time and entry point printed on the ticket; early or late entry can be refused." },
      { name: "Prohibited Items", description: "Do not carry mobiles, cameras or other electronic gadgets into Srivari Temple. Use TTD deposit counters." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "30.3", low: "18.8" },
        { month: "Feb", high: "33.3", low: "19.9" },
        { month: "Mar", high: "37.1", low: "22.9" },
        { month: "Apr", high: "39.3", low: "26.3" },
        { month: "May", high: "40.5", low: "28.1" },
        { month: "Jun", high: "38.1", low: "27.4" },
        { month: "Jul", high: "36.1", low: "26.3" },
        { month: "Aug", high: "35.1", low: "25.9" },
        { month: "Sep", high: "34.9", low: "25.3" },
        { month: "Oct", high: "33.1", low: "23.9" },
        { month: "Nov", high: "30.4", low: "22.0" },
        { month: "Dec", high: "29.2", low: "20.0" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 07:00 AM",
        morningClose: "Approx. 07:00 PM",
        eveningOpen: "Approx. 08:00 PM",
        eveningClose: "Approx. 12:30 AM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Suprabhatam", time: "02:30 AM - 03:00 AM" },
        { name: "Thomala Seva", time: "Approx. 03:30 AM - 04:00 AM; weekday variations apply" },
        { name: "Sahasranama Archana", time: "Approx. 04:15 AM - 05:00 AM; weekday variations apply" },
        { name: "Sahasra Deepalankarana Seva", time: "Approx. 05:30 PM - 06:30 PM" },
        { name: "Ekanta Seva", time: "Approx. 12:45 AM" }
      ]
    },
    transportation: [
      {
        mode: "Flight",
        startPoint: "Tirupati International Airport, Renigunta",
        endPoint: "Tirupati / Tirumala",
        distanceKm: 38,
        duration: "Approx. 1-1.5 hrs to Tirumala by road",
        cost: "Taxi approx. ₹800-₹1,000; taxi + bus approx. ₹210-₹400",
        extraInfo: "Airport is about 15 km from Tirupati; continue by taxi/bus to Tirumala."
      },
      {
        mode: "Train",
        startPoint: "Tirupati Railway Station",
        endPoint: "Tirumala",
        distanceKm: 26,
        duration: "Approx. 1 hr by road",
        cost: "₹90 adult / ₹50 child one way; return ₹160 adult / ₹90 child",
        extraInfo: "APSRTC/TTD-linked local transport available."
      },
      {
        mode: "Bus",
        startPoint: "Tirupati",
        endPoint: "Tirumala",
        distanceKm: 26,
        duration: "Approx. 1 hr",
        cost: "₹90 adult / ₹50 child one way; return ₹160 adult / ₹90 child",
        extraInfo: "APSRTC buses operate on the ghat road; ghat-road movement is restricted during late-night closure hours."
      },
      {
        mode: "Trek",
        startPoint: "Alipiri",
        endPoint: "Tirumala",
        distanceKm: 11,
        duration: "Approx. 3-5 hrs",
        cost: "Free",
        extraInfo: "Longer traditional footpath; drinking water, toilets, shelters, medical help and free luggage transport are provided."
      },
      {
        mode: "Trek",
        startPoint: "Srivari Mettu",
        endPoint: "Tirumala",
        distanceKm: 6,
        duration: "Approx. 2-3 hrs",
        cost: "Free",
        extraInfo: "Shorter footpath; facilities and free luggage transport are provided."
      }
    ],
    accommodation: [
      {
        type: "TTD Rest Houses / Cottages",
        location: "Tirumala",
        costRange: "Varies by room/rest-house category",
        bookingInfo: "Advance and current booking through TTD; availability is limited during peak periods."
      },
      {
        type: "Pilgrim Amenities Complex / Free Choultry",
        location: "Tirumala",
        costRange: "Free/basic pilgrim accommodation where allotted",
        bookingInfo: "Subject to TTD availability and allotment."
      },
      {
        type: "Hotels / TTD Accommodation",
        location: "Tirupati",
        costRange: "Varies",
        bookingInfo: "TTD and private accommodation available in Tirupati."
      }
    ],
    gates: [
      { name: "Vaikuntham Queue Complex", description: "Primary queue-entry system for free Sarva Darshan.", location: "Tirumala", isOpen: true },
      { name: "₹300 Special Entry Darshan Complex", description: "Entry/reporting complex for booked Special Entry Darshan pilgrims.", location: "Tirumala", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free TTD luggage and mobile deposit counters operate round the clock at major pilgrim points.", isAvailable: true },
      { name: "Shoe Stand", description: "QR-based footwear deposit counters are available at multiple locations.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobiles and electronic gadgets not allowed inside Srivari Temple; deposit before darshan.", isAvailable: false },
      { name: "Photography", description: "Photography not allowed inside Srivari Temple.", isAvailable: false },
      { name: "Videography", description: "Videography not allowed inside Srivari Temple.", isAvailable: false },
      { name: "Drinking Water", description: "Free drinking water available in queue complexes, footpaths and pilgrim areas.", isAvailable: true },
      { name: "Toilets", description: "Free toilets available in queue complexes, pilgrim facilities and along footpaths.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free Annaprasadam and paid food outlets available.", isAvailable: true },
      { name: "Prasad", description: "Srivari Laddu Prasadam available after darshan; TTD has stated one free laddu plus additional ₹50 laddus.", isAvailable: true, price: "Standard laddu: ₹50" },
      { name: "Medical Facility", description: "Aswini Hospital ~1.5 km; TTD also runs medical centres near Srivari Temple. Sri Srinivasa Medical Shop near the RTC Bus Stand ~1 km.", isAvailable: true },
      { name: "Wheelchair / Accessibility Assistance", description: "Special darshan and assistance available for eligible senior citizens, differently abled and specified medical cases.", isAvailable: true },
      { name: "Parking", description: "Parking areas available at Tirumala; follow TTD traffic and ghat-road restrictions.", isAvailable: true },
      { name: "Special Entry Darshan", description: "Faster time-slot darshan through ₹300 Special Entry Darshan.", isAvailable: true, price: "₹300" }
    ],
    specialServices: [
      { name: "₹300 Special Entry Darshan", description: "Booked time-slot darshan through the TTD portal.", price: "₹300", extraInfo: "Report only at the allotted time." },
      { name: "Special Darshan for Senior Citizens / Differently Abled", description: "Advance-booked special darshan for eligible categories.", price: "Free", extraInfo: "Senior citizen: 65+ with Aadhaar; specified disability/medical documents required." },
      { name: "Kalyanakatta Tonsure", description: "Free tonsure at the main and mini Kalyanakattas.", price: "Free", extraInfo: "Computer-generated tokens; main centre operates round the clock." },
      { name: "Free Annaprasadam", description: "Free meals served to pilgrims at TTD Annaprasadam facilities.", price: "Free" },
      { name: "Free Luggage / Mobile Deposit", description: "TTD counters securely store luggage, bags and mobile phones.", price: "Free", extraInfo: "Collect items using the issued QR/token receipt." },
      { name: "Free Footpath Luggage Transport", description: "Deposit luggage at Alipiri or Srivari Mettu and collect it in Tirumala.", price: "Free" }
    ],
    nearbyPlaces: [
      { name: "Sri Bhu Varaha Swamy Temple", description: "Sacred temple beside Swami Pushkarini; traditionally visited before Sri Venkateswara darshan." },
      { name: "Sri Bedi Anjaneya Swamy Temple", description: "Hanuman temple opposite the Srivari Temple area." },
      { name: "Swami Pushkarini", description: "Sacred temple tank beside the main temple." },
      { name: "Akasa Ganga", description: "Sacred waterfall/theertham in the Tirumala hills." },
      { name: "Papavinasanam", description: "Popular sacred theertham and pilgrim stop in Tirumala." },
      { name: "Sila Thoranam", description: "Natural rock arch and important Tirumala landmark." },
      { name: "Sri Padmavathi Ammavari Temple, Tiruchanoor", description: "Major TTD temple near Tirupati dedicated to Goddess Padmavathi." }
    ],
    images: { thumbnailImage: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Tirumala_Venkateswara_temple_entrance_09062015.JPG" },
    management: {
      trustName: "Tirumala Tirupati Devasthanams (TTD)",
      website: "https://www.tirumala.org",
      contactNumber: "155257; 0877-2233333; 0877-2277777; WhatsApp: 9399399399"
    }
  },
  {
    slNo: "6",
    slug: "shirdi-sai-baba",
    generalInfo: {
      templeName: "Shri Saibaba Samadhi Mandir",
      templeDescription: "Shri Saibaba Samadhi Mandir in Shirdi, Maharashtra, is the principal shrine dedicated to Sai Baba of Shirdi and houses his Samadhi and marble image. It is the centre of the wider Sai Baba temple complex, which also includes Dwarkamai, Gurusthan, Chavadi and Lendi Garden. The shrine is administered by Shree Saibaba Sansthan Trust, Shirdi. Daily worship begins before dawn, regular darshan starts after the morning rituals, and four principal aartis are performed each day.",
      location: "Shirdi, Ahmednagar district, Maharashtra",
      deity: "Sai Baba of Shirdi",
      trekPoints: [],
      dressCode: "No compulsory temple-specific dress code is specified. Wear modest clothing suitable for a place of worship."
    },
    timeInfo: {
      bestTime: "October - March for milder weather.",
      peakTime: "Thursdays, Guru Purnima, Ram Navami, Vijayadashami/Dussehra, Christmas-New Year period and major holidays."
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Typical Daily Range", totalYatra: "25,000" },
        { month: "Festival Daily Range", totalYatra: "100,000+" },
        { month: "25 Dec 2025 - 2 Jan 2026", totalYatra: "800,000+" }
      ]
    },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "General darshan is available through the temple queue; no compulsory advance registration was found.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "N/A",
        location: "Samadhi Mandir queue",
        website: "https://sai.org.in",
        validity: "Current visit"
      },
      {
        name: "Online Darshan / Aarti Booking",
        description: "Advance booking is available for darshan, aarti, pooja and accommodation.",
        isMandatory: false,
        method: "Online",
        cost: "Varies by service",
        requiredDocs: "One valid photo ID such as Aadhaar, Voter ID, PAN, Passport, Ration Card or Driving Licence",
        location: "Online / designated reporting point",
        website: "https://online.sai.org.in",
        validity: "Booked date/time"
      }
    ],
    prerequisites: [
      { name: "Photo ID for Online Services", description: "Carry the same valid photo ID entered during online booking for verification." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "29", low: "14" },
        { month: "Feb", high: "32", low: "17" },
        { month: "Mar", high: "35", low: "21" },
        { month: "Apr", high: "39", low: "25" },
        { month: "May", high: "40", low: "26" },
        { month: "Jun", high: "34", low: "24" },
        { month: "Jul", high: "30", low: "23" },
        { month: "Aug", high: "29", low: "22" },
        { month: "Sep", high: "30", low: "22" },
        { month: "Oct", high: "32", low: "20" },
        { month: "Nov", high: "31", low: "17" },
        { month: "Dec", high: "29", low: "14" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:45 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "After 10:00 PM Shej Aarti"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Kakad Aarti", time: "05:15 AM" },
        { name: "Aarti - Shirdi Majhe Pandharpur", time: "06:20 AM" },
        { name: "Madhyan Aarti", time: "12:00 PM" },
        { name: "Dhoop Aarti", time: "At sunset" },
        { name: "Shej Aarti", time: "10:00 PM" }
      ]
    },
    transportation: [
      {
        mode: "Flight",
        startPoint: "Shirdi Airport",
        endPoint: "Samadhi Mandir",
        distanceKm: 14,
        duration: "Approx. 25-35 mins",
        cost: "Cab ₹526 onwards + taxes/charges; dynamic fare",
        extraInfo: "Taxi/autorickshaw available."
      },
      {
        mode: "Train",
        startPoint: "Sainagar Shirdi Railway Station",
        endPoint: "Samadhi Mandir",
        distanceKm: 3,
        duration: "Approx. 10-15 mins",
        cost: "N/A",
        extraInfo: "Auto/taxi available."
      },
      {
        mode: "Bus",
        startPoint: "Shirdi Bus Stand",
        endPoint: "Samadhi Mandir",
        distanceKm: null,
        duration: "Few minutes",
        cost: "N/A",
        extraInfo: "MSRTC and private buses connect Shirdi with major Maharashtra cities."
      }
    ],
    accommodation: [
      {
        type: "Sai Bhakta Niwas",
        location: "Approx. 1.3 km from temple",
        costRange: "From ₹200 for listed non-AC room categories",
        bookingInfo: "Sansthan booking; room category and availability vary."
      },
      {
        type: "Sai Ashram Bhaktniwas",
        location: "Approx. 1.7 km from temple",
        costRange: "Approx. ₹250 non-AC / ₹600 AC for listed room categories",
        bookingInfo: "Sansthan booking."
      },
      {
        type: "Dwarawati",
        location: "Approx. 0.5 km from temple",
        costRange: "Approx. ₹500 non-AC / ₹900 AC for listed room categories",
        bookingInfo: "Sansthan booking."
      }
    ],
    gates: [
      { name: "Gate 3", description: "Important pilgrim assistance point; announcement centre is located nearby.", location: "Temple complex", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Sansthan lockers available at nominal charge.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit facilities are available around the temple approach.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking-water facilities available in Sansthan pilgrim complexes.", isAvailable: true },
      { name: "Toilets", description: "Toilets available in Sansthan accommodation and pilgrim facilities.", isAvailable: true },
      { name: "Restaurants / Food", description: "Shri Sai Prasadalaya serves free meals; paid dining is also available.", isAvailable: true, price: "Free main-hall meals" },
      { name: "Prasad", description: "Prasad counters available in the temple complex.", isAvailable: true },
      { name: "Medical Facility", description: "Shri Sai Baba Hospital ~0.5 km. Jay Sai Medical & General, Pimpalwadi Road ~0.5 km.", isAvailable: true },
      { name: "Wheelchair / Accessibility Assistance", description: "Assistance is available through temple staff/security.", isAvailable: true },
      { name: "Parking", description: "Free parking for two-wheelers, cars and buses with CCTV surveillance.", isAvailable: true, price: "Free" }
    ],
    specialServices: [
      { name: "Online Darshan / Aarti / Pooja Booking", description: "Booking portal for darshan, aarti and pooja services.", price: "Varies", extraInfo: "Photo ID details are verified at Shirdi." },
      { name: "Break Darshan", description: "Controlled faster-darshan facility introduced by the Sansthan for eligible/paid users.", price: "Verify current tariff" },
      { name: "Shri Sai Prasadalaya", description: "Large free community meal facility operated by the Sansthan.", price: "Free main hall" }
    ],
    nearbyPlaces: [
      { name: "Dwarkamai", description: "Historic mosque closely associated with Sai Baba, within the temple complex." },
      { name: "Gurusthan", description: "Sacred site in the temple complex associated with Sai Baba's early years." },
      { name: "Chavadi", description: "Historic place where Sai Baba spent alternate nights." },
      { name: "Lendi Garden", description: "Garden associated with Sai Baba's daily routine." },
      { name: "Shani Shingnapur", description: "Major Shani pilgrimage site near Shirdi." }
    ],
    images: { thumbnailImage: "https://hotelsaichhatra.com/images/uploads/427/3786Samadhi_Mandir.png" },
    management: {
      trustName: "Shree Saibaba Sansthan Trust, Shirdi",
      website: "https://sai.org.in",
      contactNumber: "02423-258500; PRO: 02423-258777; Online services: 02423-258965/258966"
    }
  },
  {
    slNo: "7",
    slug: "jagannath-puri",
    generalInfo: {
      templeName: "Shree Jagannath Temple",
      templeDescription: "Shree Jagannath Temple in Puri, Odisha, is one of Hinduism's four Char Dham pilgrimage sites. The 12th-century temple enshrines Lord Jagannath with his elder brother Balabhadra and sister Subhadra on the Ratna Simhasana. It is the centre of the Jagannath tradition and the world-famous annual Ratha Yatra. The shrine is administered under the Shree Jagannath Temple Administration (SJTA). Entry rules are unusually strict: non-Hindus are not permitted inside, and mobiles, cameras, electronic gadgets, footwear and leather items are prohibited.",
      location: "Puri, Odisha",
      deity: "Lord Jagannath, Lord Balabhadra and Devi Subhadra",
      trekPoints: [],
      dressCode: "Decent clothing is mandatory. Shorts, half pants, torn jeans, skirts and sleeveless dresses are not allowed. Traditional/modest Indian clothing is recommended."
    },
    timeInfo: {
      bestTime: "October - April for more comfortable weather. The temple is visited year-round.",
      peakTime: "Ratha Yatra, Snana Yatra, Bahuda Yatra, Suna Besha, Kartika month, weekends and major holidays."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "General temple entry/darshan is free for eligible Hindu devotees; follow the queue system.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "Carry government ID where required by security or special entry arrangements",
        location: "Primarily Singhadwara (Lion Gate)",
        website: "https://shreejagannatha.in",
        validity: "Current visit"
      }
    ],
    prerequisites: [
      { name: "Religious Entry Restriction", description: "Non-Hindus are not permitted inside the main temple complex." },
      { name: "Prohibited Items", description: "Do not carry mobile phones, cameras, electronic gadgets, footwear, umbrellas or leather items into the temple." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "30.0", low: "13.8" },
        { month: "Feb", high: "31.9", low: "16.8" },
        { month: "Mar", high: "33.8", low: "21.1" },
        { month: "Apr", high: "34.3", low: "22.5" },
        { month: "May", high: "35.5", low: "22.5" },
        { month: "Jun", high: "35.2", low: "23.7" },
        { month: "Jul", high: "34.6", low: "24.0" },
        { month: "Aug", high: "34.5", low: "24.2" },
        { month: "Sep", high: "34.8", low: "24.1" },
        { month: "Oct", high: "34.5", low: "21.9" },
        { month: "Nov", high: "32.4", low: "17.6" },
        { month: "Dec", high: "30.4", low: "14.7" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "Approx. 04:30 AM",
        morningClose: "Darshan varies around rituals",
        eveningOpen: "Darshan windows vary",
        eveningClose: "Approx. 11:30 PM ritual closure"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangala Alati", time: "Approx. 05:30 AM" },
        { name: "Gopala Ballava Bhoga", time: "Approx. 08:30 AM" },
        { name: "Sakala Dhupa", time: "Approx. 09:00 AM - 10:00 AM" },
        { name: "Sandhya Alati", time: "Approx. 06:00 PM" },
        { name: "Sandhya Dhupa", time: "Approx. 06:30 PM - 08:00 PM" },
        { name: "Badasinghara Dhupa", time: "Approx. 10:30 PM - 11:00 PM" }
      ]
    },
    transportation: [
      {
        mode: "Flight",
        startPoint: "Biju Patnaik International Airport, Bhubaneswar",
        endPoint: "Puri",
        distanceKm: 60,
        duration: "Approx. 1.5-2 hrs",
        cost: "Cab ₹668 onwards + taxes/charges; dynamic fare",
        extraInfo: "Taxi/bus available."
      },
      {
        mode: "Train",
        startPoint: "Puri Railway Station",
        endPoint: "Shree Jagannath Temple",
        distanceKm: 3,
        duration: "Approx. 10-15 mins",
        cost: "Taxi approx. ₹85-₹110",
        extraInfo: "Auto, e-rickshaw and taxi available."
      },
      {
        mode: "Bus",
        startPoint: "Bhubaneswar",
        endPoint: "Puri",
        distanceKm: 60,
        duration: "Approx. 1.5-2 hrs",
        cost: "₹73 onwards by bus",
        extraInfo: "Regular state/private bus and taxi services."
      }
    ],
    accommodation: [
      { type: "Neeladri Bhakta Niwas", location: "Near Town Police Station, Grand Road, Puri", costRange: "Varies", bookingInfo: "SJTA accommodation: stayatpurijagannatha.in" },
      { type: "Shree Gundicha Bhakta Niwas", location: "Near Gundicha Temple, Puri", costRange: "Varies", bookingInfo: "SJTA accommodation." },
      { type: "Nilachala Bhakta / Yatri Niwas", location: "Grand Road, Puri", costRange: "Varies", bookingInfo: "SJTA accommodation." }
    ],
    gates: [
      { name: "Singhadwara (Lion Gate)", description: "Main eastern entrance and primary devotee entry.", location: "Eastern side / Grand Road", isOpen: true },
      { name: "Hathidwara (Elephant Gate)", description: "Northern gate; access may be regulated.", location: "North side", isOpen: true },
      { name: "Vyaghradwara (Tiger Gate)", description: "Southern gate; regulated entry.", location: "South side", isOpen: true },
      { name: "Ashwadwara (Horse Gate)", description: "Western gate; regulated entry.", location: "West side", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Deposit prohibited belongings outside the temple; official deposit facilities operate near main entrance.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear must be removed; stands available near temple approach.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobile phones and electronic gadgets not allowed inside temple premises.", isAvailable: false },
      { name: "Photography", description: "Photography not allowed inside temple premises.", isAvailable: false },
      { name: "Videography", description: "Videography not allowed inside temple premises.", isAvailable: false },
      { name: "Drinking Water", description: "Drinking-water arrangements provided around pilgrim zones.", isAvailable: true },
      { name: "Toilets", description: "Public sanitation facilities available around Grand Road.", isAvailable: true },
      { name: "Restaurants / Food", description: "Mahaprasad and vegetarian food available in and around the temple area.", isAvailable: true },
      { name: "Prasad", description: "Mahaprasad is available at Anand Bazaar within the temple complex for eligible entrants.", isAvailable: true },
      { name: "Medical Facility", description: "District Headquarters Hospital ~1.5 km. Apollo Pharmacy, Dolamandap Sahi ~0.5 km.", isAvailable: true },
      { name: "Wheelchair / Accessibility Assistance", description: "Wheelchairs, ramps and assistance provided for elderly and differently abled devotees.", isAvailable: true }
    ],
    specialServices: [
      { name: "Mahaprasad", description: "Sacred cooked offerings are available through the temple's Anand Bazaar.", price: "Varies" },
      { name: "SJTA Bhakta Niwas Booking", description: "Pilgrim accommodation booking service.", price: "Varies", extraInfo: "Use only shreejagannatha.in / stayatpurijagannatha.in." }
    ],
    nearbyPlaces: [
      { name: "Shree Gundicha Temple", description: "Ratha Yatra destination of Lord Jagannath and siblings, on Grand Road." },
      { name: "Puri Beach / Swargadwar", description: "Sacred coastal area and major Puri landmark." },
      { name: "Loknath Temple", description: "Important Shiva temple in Puri." },
      { name: "Konark Sun Temple", description: "UNESCO-listed Sun Temple around 35 km from Puri." }
    ],
    images: { thumbnailImage: "https://d2gsigjpujdc9o.cloudfront.net/cozzet/cozzimages/blogs/jagannath-temple-puri_1780910380.jpg" },
    management: {
      trustName: "Shree Jagannath Temple Administration (SJTA), Puri",
      website: "https://shreejagannatha.in",
      contactNumber: "06752-222002; 06752-252302"
    }
  },
  {
    slNo: "8",
    slug: "baidyanath-dham",
    generalInfo: {
      templeName: "Baba Baidyanath Dham Temple",
      templeDescription: "Baba Baidyanath Dham in Deoghar, Jharkhand, is one of the twelve Jyotirlinga shrines of Lord Shiva and is also traditionally revered as a Shakti Peetha. The main shrine stands in a complex with 21 subsidiary temples. During Shravan, millions of Kanwariyas carry Ganga water from Sultanganj on the roughly 109 km pilgrimage route and offer it to the Jyotirlinga. The pilgrimage area is administered through the Baba Baidyanathdham-Basukinath Pilgrimage Area Development Authority and Deoghar district administration.",
      location: "Deoghar, Jharkhand",
      deity: "Lord Shiva (Baba Baidyanath / Vaidyanath Jyotirlinga)",
      trekPoints: [
        { name: "Sultanganj", distanceKm: 0 },
        { name: "Baba Baidyanath Dham, Deoghar", distanceKm: 109 }
      ],
      dressCode: "Wear modest, comfortable clothing; Kanwariyas commonly wear saffron during Shravan. Avoid carrying prohibited items into controlled temple areas."
    },
    timeInfo: {
      bestTime: "October - February for more comfortable weather. The temple is open year-round.",
      peakTime: "Shravan / Shravani Mela (July-August), especially Mondays; also Maha Shivaratri, Basant Panchami and Bhadra Purnima."
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Shravan first fortnight", totalYatra: "2,833,000" },
        { month: "Shravani Mela typical month", totalYatra: "5,000,000-5,500,000" }
      ]
    },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "No verified compulsory advance registration for ordinary year-round darshan. Follow onsite queue and security arrangements.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "Government ID advisable",
        location: "Baba Baidyanath Temple complex",
        website: "https://deoghar.nic.in/",
        validity: "Current visit"
      },
      {
        name: "Sheeghra Darshan",
        description: "Fast-track darshan operated with a separate queue.",
        isMandatory: false,
        method: "Coupon / onsite arrangement",
        cost: "₹600 during Shravani Mela",
        requiredDocs: "N/A",
        location: "Sheeghra Darshan holding/queue area",
        website: "https://deoghar.nic.in/shrawani-mela-2/",
        validity: "Festival-specific; price/rules may change"
      }
    ],
    prerequisites: [
      { name: "Kanwar Yatra Route", description: "Shravan Kanwariyas traditionally collect Ganga water at Sultanganj and walk about 109 km to Deoghar." },
      { name: "Prohibited Items", description: "Mobiles and bags may be barred from temple complex during peak periods. Mobile use prohibited in garbhagriha." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "22.2", low: "10.3" },
        { month: "Feb", high: "26.3", low: "13.5" },
        { month: "Mar", high: "31.9", low: "18.1" },
        { month: "Apr", high: "36.4", low: "22.6" },
        { month: "May", high: "35.9", low: "24.8" },
        { month: "Jun", high: "33.7", low: "25.8" },
        { month: "Jul", high: "30.6", low: "24.9" },
        { month: "Aug", high: "30.3", low: "24.7" },
        { month: "Sep", high: "30.0", low: "23.9" },
        { month: "Oct", high: "29.0", low: "20.6" },
        { month: "Nov", high: "26.5", low: "15.7" },
        { month: "Dec", high: "23.1", low: "11.7" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:00 AM",
        morningClose: "02:00 PM",
        eveningOpen: "06:00 PM",
        eveningClose: "08:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Opening / Puja", time: "From 04:00 AM" },
        { name: "Evening Shringar Puja", time: "Approx. 06:00 PM onward" }
      ]
    },
    transportation: [
      {
        mode: "Flight",
        startPoint: "Deoghar Airport",
        endPoint: "Baba Baidyanath Dham",
        distanceKm: 12,
        duration: "Approx. 25-35 mins",
        cost: "Taxi approx. ₹380-₹460",
        extraInfo: "Airport is about 12 km from Deoghar city; taxi/cab available."
      },
      {
        mode: "Train",
        startPoint: "Jasidih Junction",
        endPoint: "Baba Baidyanath Dham",
        distanceKm: 7,
        duration: "Approx. 20-30 mins",
        cost: "Taxi approx. ₹340-₹420; local train ₹100-₹850 by class",
        extraInfo: "Major railhead with wider long-distance connectivity."
      },
      {
        mode: "Trek / Kanwar Yatra",
        startPoint: "Sultanganj",
        endPoint: "Baba Baidyanath Dham",
        distanceKm: 109,
        duration: "Usually several days",
        cost: "Free trek; personal expenses extra",
        extraInfo: "Traditional Shravan route carrying Ganga water."
      }
    ],
    accommodation: [
      { type: "Yatri Niwas", location: "Baba Dham Yatri Niwas, Gouri Road, about 200 m from Temple", costRange: "₹896-₹2,240 + taxes", bookingInfo: "Parking, hot water, CCTV and drinking water listed." },
      { type: "Private Hotel", location: "Hotel Baidyanath, Castair Town, Deoghar; approx. 0.9 km from Temple", costRange: "Varies by date", bookingInfo: "Nearby private accommodation near Baba Baidyanath Temple." }
    ],
    gates: [
      { name: "Temple Queue Complex / Regulated Entry", description: "Primary crowd-management approach during high-footfall periods.", location: "Baba Baidyanath Temple area", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Locker/cloak assistance and deposit arrangements are available around the queue system.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear must be removed before entering the shrine; deposit arrangements available.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobile use is prohibited in the garbhagriha.", isAvailable: false },
      { name: "Drinking Water", description: "Drinking-water and cooling arrangements provided at pilgrim/queue points.", isAvailable: true },
      { name: "Toilets", description: "Public sanitation facilities provided around pilgrimage area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Food outlets and regulated vendors available around Deoghar.", isAvailable: true },
      { name: "Prasad", description: "Prasad and puja offerings available around the temple.", isAvailable: true },
      { name: "Medical Facility", description: "Sadar Hospital ~0.6 km. Ganpati Medicals ~1 km.", isAvailable: true }
    ],
    specialServices: [
      { name: "Sheeghra Darshan", description: "Fast-track queue during Shravani Mela.", price: "₹600 per coupon", extraInfo: "Verify current tariff before booking." },
      { name: "External Argha Water Offering", description: "External argha arrangement helps devotees offer water comfortably.", price: "Free" }
    ],
    nearbyPlaces: [
      { name: "Shivaganga", description: "Sacred tank near Baba Dham; Kanwariyas traditionally bathe here before temple darshan." },
      { name: "Naulakha Mandir", description: "Prominent Radha-Krishna temple in Deoghar." },
      { name: "Basukinath Temple", description: "Important Shiva pilgrimage site often visited with Baidyanath Dham." }
    ],
    images: { thumbnailImage: "https://cdn.shopify.com/s/files/1/0825/8404/3804/files/Feature_Image_a7b170a1-7e93-4d92-ad32-ce2ddafff3e5.png?v=1771304939" },
    management: {
      trustName: "Baba Baidyanathdham-Basukinath Pilgrimage Area Development Authority / Deoghar District Administration",
      website: "https://deoghar.nic.in/",
      contactNumber: "Baba Mandir: 06432-232680"
    }
  },
  {
    slNo: "9",
    slug: "somnath-temple",
    generalInfo: {
      templeName: "Shree Somnath Temple",
      templeDescription: "Shree Somnath Temple at Prabhas Patan on Gujarat's Arabian Sea coast is revered by the Shree Somnath Trust as the first among the twelve Aadi Jyotirlingas of Lord Shiva. The present temple was consecrated in 1951. Somnath is also part of the sacred Prabhas Tirth area associated with the final earthly journey of Lord Krishna. Darshan is free, and the Trust provides extensive pilgrim facilities including free cloak-room lockers, shoe storage, accessibility support, accommodation and online pooja/prasad services.",
      location: "Prabhas Patan, Gir Somnath, Gujarat",
      deity: "Lord Shiva (Somnath Jyotirlinga)",
      trekPoints: [],
      dressCode: "Modest dress required. Sarees, dhoti, pants, T-shirts and skirts are allowed; mini-skirts and disrespectful/revealing dress are not permitted."
    },
    timeInfo: {
      bestTime: "October - March for pleasant weather. Temple is open year-round.",
      peakTime: "Shravan month, Maha Shivaratri, Kartik Purnima fair, Somnath Sthapana Divas and major holidays."
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "No advance registration required for normal darshan.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "N/A",
        location: "Main temple entrance",
        website: "https://somnath.org/",
        validity: "Current visit"
      }
    ],
    prerequisites: [
      { name: "Prohibited Electronics", description: "Mobiles, cameras, smartwatches, laptops, tablets and other electronic gadgets not allowed inside; deposit them in free cloak-room lockers." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "28.3", low: "16.1" },
        { month: "Feb", high: "29.4", low: "18.3" },
        { month: "Mar", high: "31.1", low: "21.1" },
        { month: "Apr", high: "32.2", low: "24.4" },
        { month: "May", high: "33.3", low: "27.2" },
        { month: "Jun", high: "32.8", low: "28.3" },
        { month: "Jul", high: "30.6", low: "27.2" },
        { month: "Aug", high: "29.4", low: "26.7" },
        { month: "Sep", high: "30.6", low: "26.1" },
        { month: "Oct", high: "33.3", low: "25.0" },
        { month: "Nov", high: "32.8", low: "21.7" },
        { month: "Dec", high: "30.0", low: "17.8" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:00 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "10:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "07:00 AM" },
        { name: "Noon Aarti", time: "12:00 PM" },
        { name: "Evening Aarti", time: "07:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Diu Airport", endPoint: "Somnath", distanceKm: 95, duration: "Approx. 2 hrs", cost: "Approx. ₹2,000 by cab" },
      { mode: "Train", startPoint: "Veraval Railway Station", endPoint: "Somnath Temple", distanceKm: 7, duration: "Approx. 15-25 mins", cost: "Approx. ₹15 by auto-rickshaw" },
      { mode: "Road", startPoint: "Ahmedabad", endPoint: "Somnath", distanceKm: 425, duration: "Approx. 8-9 hrs", cost: "Bus ₹296 onwards; cab ₹5,000 onwards" }
    ],
    accommodation: [
      { type: "Lilavati Atithi Bhavan", location: "Somnath", costRange: "From approx. ₹1,000", bookingInfo: "Book through Somnath.org; 2-bed Non-AC and AC rooms available." },
      { type: "Sagar Darshan Guest House", location: "Near Somnath Temple", costRange: "Approx. ₹4,400-₹6,000", bookingInfo: "Sea-view Trust guest house; online booking through Somnath.org." },
      { type: "Trust Dormitory", location: "Somnath", costRange: "Non-AC ₹90 / AC ₹200", bookingInfo: "Trust dormitory; verify current tariff before travel." }
    ],
    gates: [
      { name: "Main Gate", description: "Main pilgrim entry; wheelchair and golf-cart assistance available here.", location: "Shree Somnath Temple", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Free cloak-room lockers for mobiles, cameras and prohibited electronics.", isAvailable: true },
      { name: "Shoe Stand", description: "Free shoe house near the cloak room.", isAvailable: true },
      { name: "Mobile Phone Restrictions", description: "Mobiles and other electronic gadgets strictly prohibited inside.", isAvailable: false },
      { name: "Drinking Water", description: "Pilgrim amenities available in the temple complex.", isAvailable: true },
      { name: "Toilets", description: "Public sanitation facilities available around complex.", isAvailable: true },
      { name: "Restaurants / Food", description: "Trust guest houses include restaurant facilities; local vegetarian food widely available.", isAvailable: true },
      { name: "Prasad", description: "Laddu prasadi, Gangalal, prasadi vastra available at counters; online prasad offered.", isAvailable: true },
      { name: "Wheelchair", description: "Wheelchairs and golf carts available for physically challenged devotees and senior citizens at Main Gate.", isAvailable: true },
      { name: "Parking", description: "Parking available in Somnath pilgrim area.", isAvailable: true }
    ],
    specialServices: [
      { name: "Wheelchair / Golf Cart Assistance", description: "Available at the Main Gate for senior citizens and physically challenged devotees.", price: "Free" },
      { name: "Tirth Darshan Bus", description: "Trust sightseeing bus for nearby pilgrimage sites.", price: "Nominal charges", extraInfo: "Departures around 08:30 AM and 03:30 PM." },
      { name: "Jay Somnath Sound & Light Show", description: "Evening sound-and-light show near the temple.", price: "Ticketed", extraInfo: "Evening shows around 07:45 PM - 08:00 PM." }
    ],
    nearbyPlaces: [
      { name: "Bhalka Tirth", description: "Sacred site associated with Lord Krishna's final earthly episode." },
      { name: "Triveni Sangam", description: "Confluence pilgrimage site in Prabhas Patan." },
      { name: "Dehotsarg / Golok Dham", description: "Sacred place associated with Lord Krishna's departure to Neejdham." }
    ],
    images: { thumbnailImage: "https://2.bp.blogspot.com/-gVglkLRORDA/Uh2oZK6zzdI/AAAAAAAAAbM/5P3ppdI_Qxo/s1600/Somnath_mandir.jpg" },
    management: {
      trustName: "Shree Somnath Trust",
      website: "https://somnath.org/",
      contactNumber: "+91-2876-232694; +91-2876-231212; +91-94282 14914"
    }
  },
  {
    slNo: "11",
    slug: "sabarimala",
    generalInfo: {
      templeName: "Sabarimala Sree Dharma Sastha Temple",
      templeDescription: "Sabarimala Sree Dharma Sastha Temple in the forested hills of Pathanamthitta district, Kerala, is dedicated to Lord Ayyappa and is one of India's largest seasonal pilgrimages. The main Mandala-Makaravilakku season runs roughly from mid-November through January, with additional monthly openings announced by the Travancore Devaswom Board. Pilgrims generally reach Pamba/Nilakkal and trek to Sannidhanam via the regulated forest-hill route. Virtual-queue booking, strict crowd control, mobile restrictions and extensive seasonal medical, water, food, accommodation and parking arrangements apply.",
      location: "Sannidhanam, Pathanamthitta, Kerala",
      deity: "Lord Ayyappa (Sree Dharma Sastha)",
      trekPoints: [
        { name: "Pamba", distanceKm: 0 },
        { name: "Marakoottam", distanceKm: 2.5 },
        { name: "Saramkuthy", distanceKm: 3.5 },
        { name: "Sannidhanam", distanceKm: 4.5 }
      ],
      dressCode: "Traditional Sabarimala pilgrims commonly wear simple black, blue or saffron clothing. Wear modest clothing suitable for a forest pilgrimage. Irumudi-carrying devotees follow the traditional Pathinettampadi ritual rules."
    },
    timeInfo: {
      bestTime: "Mandala-Makaravilakku season (November-January) for the main pilgrimage; check opening calendar before travel.",
      peakTime: "Mandala season, Makaravilakku/Makar Sankranti, weekends and major opening days."
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Mandala-Makaravilakku season", totalYatra: "Approx. 5,300,000" }
      ]
    },
    registrationProcess: [
      {
        name: "Virtual Queue Darshan Slot",
        description: "Book a darshan slot through the Sabarimala online virtual-queue system. Seasonal spot-booking/onsite quotas may also operate at notified centres.",
        isMandatory: true,
        method: "Online / notified booking centres",
        cost: "Free",
        requiredDocs: "Valid identity details as required by portal",
        location: "sabarimalaonline.org / notified centres such as Nilakkal and Pamba",
        website: "https://sabarimalaonline.org/",
        validity: "Booked date/time slot"
      }
    ],
    prerequisites: [
      { name: "Physical Fitness", description: "The Pamba-Sannidhanam climb is steep and crowded. Rest regularly and use medical/oxygen centres if needed." },
      { name: "Security Rules", description: "Follow security checks, queue instructions and the prescribed trek/return routes. Do not carry weapons/explosives." },
      { name: "Mobile Restriction", description: "Do not use mobile phones in the temple premises." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "32.2", low: "23.3" },
        { month: "Feb", high: "32.8", low: "23.9" },
        { month: "Mar", high: "33.3", low: "25.6" },
        { month: "Apr", high: "33.9", low: "25.6" },
        { month: "May", high: "33.3", low: "25.6" },
        { month: "Jun", high: "31.1", low: "24.4" },
        { month: "Jul", high: "30.6", low: "23.9" },
        { month: "Aug", high: "30.6", low: "23.9" },
        { month: "Sep", high: "31.1", low: "24.4" },
        { month: "Oct", high: "31.1", low: "23.9" },
        { month: "Nov", high: "31.7", low: "23.9" },
        { month: "Dec", high: "32.2", low: "23.9" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "03:00 AM",
        morningClose: "01:00 PM",
        eveningOpen: "03:00 PM",
        eveningClose: "11:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Nirmalyam / Abhishekam", time: "03:00 AM" },
        { name: "Ganapati Homam", time: "03:30 AM" },
        { name: "Neyyabhishekam", time: "03:30 AM - 07:00 AM; 08:30 AM - 11:00 AM" },
        { name: "Usha Pooja", time: "From 07:30 AM" },
        { name: "Ucha Pooja", time: "12:30 PM" },
        { name: "Deeparadhana", time: "06:30 PM" },
        { name: "Athazha Pooja", time: "From 09:30 PM" },
        { name: "Harivarasanam / Closing", time: "11:00 PM" }
      ]
    },
    transportation: [
      { mode: "Road / Shuttle", startPoint: "Nilakkal", endPoint: "Pamba", distanceKm: 18, duration: "Approx. 30-45 mins", cost: "Seasonal KSRTC tariff", extraInfo: "Parking concentrated at Nilakkal; shuttles carry pilgrims to Pamba." },
      { mode: "Trek", startPoint: "Pamba", endPoint: "Sannidhanam", distanceKm: 4.5, duration: "Approx. 2-4 hrs", cost: "Free", extraInfo: "Traditional route includes Marakoottam, Saramkuthy and Nadapanthal." },
      { mode: "Dolly", startPoint: "Pamba / designated points", endPoint: "Sannidhanam", distanceKm: 4.5, duration: "Varies", cost: "Pay only at Devaswom counter", extraInfo: "Keep receipt; rates vary by season." }
    ],
    accommodation: [
      { type: "TDB Rooms at Sannidhanam", location: "Sannidhanam", costRange: "Approx. ₹250-₹1,600 depending room", bookingInfo: "Sabarimala portal; limited and seasonal." },
      { type: "Edathavalams / Pilgrim Rest Centres", location: "Multiple locations in Pathanamthitta district", costRange: "Public pilgrim support", bookingInfo: "Seasonal 24-hour rest facilities with bedding, food, water and toilets." }
    ],
    gates: [
      { name: "Pathinettampadi (Sacred 18 Steps)", description: "Traditional sacred approach to the temple; queue and ritual rules apply.", location: "Sannidhanam", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Seasonal deposit facilities operate at pilgrimage centres.", isAvailable: true },
      { name: "Drinking Water", description: "Fresh-water pipes and medicinal chukku-water counters operate along the route.", isAvailable: true },
      { name: "Toilets", description: "Toilets with bathrooms and urinals at Pamba, Nilakkal and Sannidhanam.", isAvailable: true },
      { name: "Restaurants / Food", description: "Annadanam mandapams operate at Pampa, Nilakkal and Sannidhanam.", isAvailable: true, price: "Regulated/paid & free support" },
      { name: "Prasad", description: "Appam and Aravana prasadam counters operate at Sannidhanam.", isAvailable: true },
      { name: "Medical Facility", description: "Government Hospital Sannidhanam ~0.2 km. Pampa Hospital downhill for onward care.", isAvailable: true },
      { name: "Parking", description: "16 parking grounds with capacity around 9,000 vehicles at Nilakkal.", isAvailable: true }
    ],
    specialServices: [
      { name: "Virtual Queue", description: "Timed darshan-slot system used to control seasonal footfall.", price: "Free", extraInfo: "70,000 online virtual-queue slots/day plus seasonal onsite arrangements." },
      { name: "Dolly Service", description: "Assisted carrying service on the climb; use only authorised Devaswom counters.", price: "Seasonal rate", extraInfo: "Keep receipt and avoid unauthorised operators." },
      { name: "Neyyabhishekam", description: "Principal ghee abhishekam offering during morning ritual schedule.", price: "Verify current offering rate" }
    ],
    nearbyPlaces: [
      { name: "Pamba", description: "Main pilgrimage base and start of the final trek." },
      { name: "Nilakkal Mahadeva Temple", description: "Important pilgrimage halt and major transport hub." },
      { name: "Pandalam Valiya Koyikkal", description: "Historic site associated with Lord Ayyappa tradition." }
    ],
    images: { thumbnailImage: "https://2.bp.blogspot.com/-qCqTIFFx3Eo/VYrj_xgJY0I/AAAAAAAABn0/H86teW3BVNo/w1200-h630-p-k-no-nu/sabarimala_deity.jpg" },
    management: {
      trustName: "Travancore Devaswom Board",
      website: "https://sabarimala.kerala.gov.in/",
      contactNumber: "General enquiry: 7025800100; Executive Officer: 04735-202028"
    }
  },
  {
    slNo: "12",
    slug: "omkareshwar",
    generalInfo: {
      templeName: "Shri Omkareshwar Jyotirlinga",
      templeDescription: "Shri Omkareshwar Jyotirlinga is a major Shiva shrine on Mandhata island on the Narmada River in Khandwa district, Madhya Pradesh, and is recognised by the Mandir Trust as the fourth of the twelve Jyotirlingas. The temple runs a detailed daily ritual schedule, free normal darshan, optional ₹300 Shighra Darshan, online puja services, a prasadalaya, low-cost Vishramalaya, free wheelchair assistance, first aid and help centres. The Shri Omkareshwar Mandir Trust operates under local administrative oversight.",
      location: "Omkareshwar, Khandwa district, Madhya Pradesh",
      deity: "Lord Shiva (Omkareshwar Jyotirlinga)",
      trekPoints: [
        { name: "Bramhapuri / Parking area", distanceKm: 0 },
        { name: "Mamleshwar Setu / Jhula Pul", distanceKm: 0.8 },
        { name: "Shri Omkareshwar Temple", distanceKm: 1.2 }
      ],
      dressCode: "No compulsory dress code. Regular modest attire is recommended."
    },
    timeInfo: {
      bestTime: "October - March for pleasant weather.",
      peakTime: "Shravan month and Mondays, Maha Shivaratri, Kartik Purnima, Narmada Jayanti and major holidays."
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Jan", totalYatra: "360,000" },
        { month: "Feb", totalYatra: "540,000" },
        { month: "Mar", totalYatra: "380,000" },
        { month: "Jul", totalYatra: "460,000" },
        { month: "Aug", totalYatra: "480,000" }
      ]
    },
    registrationProcess: [
      {
        name: "General Darshan",
        description: "Normal darshan is free and does not require booking.",
        isMandatory: false,
        method: "Onsite",
        cost: "Free",
        requiredDocs: "N/A",
        location: "General queue",
        website: "https://www.shriomkareshwar.org/",
        validity: "Current visit"
      },
      {
        name: "Shighra Darshan",
        description: "Optional fast-track/direct darshan with booked time slot and mandatory wristband collection.",
        isMandatory: false,
        method: "Online / counter",
        cost: "₹300",
        requiredDocs: "Aadhaar / Passport and valid ticket",
        location: "Collect wristband at distribution centre",
        website: "https://www.shriomkareshwar.org/Onlineticketbooking.aspx",
        validity: "Selected date/time slot only"
      }
    ],
    prerequisites: [
      { name: "Shighra Darshan ID", description: "Ticket holders must carry booked ticket and Aadhaar/Passport and collect wristband before entry." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "24.4", low: "11.1" },
        { month: "Feb", high: "28.3", low: "13.9" },
        { month: "Mar", high: "33.3", low: "17.2" },
        { month: "Apr", high: "37.8", low: "21.7" },
        { month: "May", high: "39.4", low: "25.0" },
        { month: "Jun", high: "35.0", low: "23.9" },
        { month: "Jul", high: "29.4", low: "22.8" },
        { month: "Aug", high: "27.8", low: "22.2" },
        { month: "Sep", high: "30.0", low: "21.7" },
        { month: "Oct", high: "32.2", low: "19.4" },
        { month: "Nov", high: "29.4", low: "15.6" },
        { month: "Dec", high: "25.6", low: "12.2" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "04:30 AM ritual opening / Darshan from 05:00 AM",
        morningClose: "12:20 PM for Madhyanha Bhog",
        eveningOpen: "01:15 PM",
        eveningClose: "10:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Mangal Aarti and Naivedya Bhog", time: "04:30 AM - 05:00 AM" },
        { name: "Madhyanha Bhog", time: "12:20 PM - 01:15 PM" },
        { name: "Sayamkalin Shringar", time: "04:00 PM - 04:30 PM" },
        { name: "Shayan Shringar and Aarti", time: "09:30 PM - 10:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Devi Ahilyabai Holkar Airport, Indore", endPoint: "Omkareshwar", distanceKm: 80, duration: "Approx. 2-2.5 hrs", cost: "Cab ₹1,085 onwards" },
      { mode: "Train", startPoint: "Indore / Dr. Ambedkar Nagar", endPoint: "Omkareshwar", distanceKm: 75, duration: "Approx. 2 hrs by road", cost: "N/A" },
      { mode: "Walk", startPoint: "Bramhapuri Parking / Help Centre", endPoint: "Omkareshwar Temple", distanceKm: 1.2, duration: "Approx. 15-30 mins", cost: "Free", extraInfo: "Use bridge/regulated pedestrian route." }
    ],
    accommodation: [
      { type: "Shreeji Vishramalaya - Night Stay", location: "Near Omkar Prasadalaya, about 1 km from temple", costRange: "₹100 per person / 24 hrs", bookingInfo: "Online booking; max stay 3 days; ID required." },
      { type: "Shreeji Vishramalaya - Day Stay", location: "Near Omkar Prasadalaya", costRange: "₹50 per person / 4 hrs", bookingInfo: "Same-day booking available subject to capacity." }
    ],
    gates: [
      { name: "Facility Center / Entry Point", description: "Wristband distribution and entry point near Mamleshwar Setu.", location: "Left of Mamleshwar Setu", isOpen: true },
      { name: "Bramhapuri Center", description: "Wristband distribution counter near parking.", location: "Bramhapuri Parking", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Vishramalaya night-stay booking includes luggage storage.", isAvailable: true },
      { name: "Shoe Stand", description: "Designated footwear stands operate near entrances.", isAvailable: true },
      { name: "Drinking Water", description: "Pure cool drinking water provided for devotees.", isAvailable: true },
      { name: "Toilets", description: "Washrooms/bathing facilities available at Vishramalaya and pilgrim facilities.", isAvailable: true },
      { name: "Restaurants / Food", description: "Omkar Prasadalaya serves meals 12:00-2:00 PM and khichdi 7:00-10:00 PM.", isAvailable: true, price: "Food coupon ₹30; khichdi ₹10" },
      { name: "Prasad", description: "Laddu Mahaprasad is sold at counter; free prasadam distributed periodically.", isAvailable: true },
      { name: "Medical Facility", description: "Temple Swasthya Kendra provides primary treatment near garbhagriha with duty doctors.", isAvailable: true },
      { name: "Wheelchair", description: "Free wheelchair service from Yatri Suvidha Kendra near Jhula Pul.", isAvailable: true, price: "Free" }
    ],
    specialServices: [
      { name: "Shighra Darshan", description: "Optional fast-track darshan with timed ticket and wristband.", price: "₹300" },
      { name: "Narmada Aarti", description: "Family participation can be booked through Trust system at Koti Tirth Ghat.", price: "₹1,500" },
      { name: "Jalabhishek", description: "Ritual booking service through Trust portal.", price: "₹2,100" }
    ],
    nearbyPlaces: [
      { name: "Mamleshwar Temple", description: "Important Shiva temple across Narmada, traditionally paired with Omkareshwar." },
      { name: "Koti Tirth Ghat", description: "Sacred Narmada ghat and location of Narmada Aarti." },
      { name: "Mandhata Parikrama", description: "Pilgrimage circuit around Mandhata island." }
    ],
    images: { thumbnailImage: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Omkareshwar_Jyotirlinga_Temple_in_Madhya_Pradesh.jpg" },
    management: {
      trustName: "Shri Omkareshwar Mandir Trust",
      website: "https://www.shriomkareshwar.org/",
      contactNumber: "+91 8989998686"
    }
  }
];
